// Module
var code = " <div *ngFor=\"let column of columns; trackBy: trackByColumn\" class=\"m-tree-column\"> <gh-checkbox-tree-item *ngFor=\"let child of column; trackBy: trackByNode\" [trackBy]=\"trackBy\" [node]=\"child\" [disabled]=\"disabled\"></gh-checkbox-tree-item> </div>";
// Exports
module.exports = code;